export const BASE_DOMAIN =
	'https://us-central1-memora-admin-platform.cloudfunctions.net/app/api/v1/stripe';
export const PUBLIC_KEY =
	'pk_test_51ISi2nFXnKyMHMzeS9JMGVaj46u104MqmtUONfIyvZNILPvZPgooNVFlPO4Wq3aZXCl8RHkTzP1e6k1s1ju89uNr00mbBy6caY';
